import Pictogram from '../pictogram';
import React from 'react';
import TranslatedCopy from '../../../intl/translated-copy';
import cx from 'classnames';
import useWizard from '../wizard/useWizard';
import { formatAmountWithDecimals } from '../../../../cms-wrapper/utils';

const RefundAccoundAndCardInfo = ({
  cardNumbers,
  currencyOfRefund,
  numberOfDecimalsBE,
  total,
}) => {
  const {
    nonRefundableExtrasExist,
  } = useWizard();

  const decimals = numberOfDecimalsBE != null ? numberOfDecimalsBE : 0;

  const nonRefundableClass = cx({
    'RefundAccoundAndCardInfo-totalToRefund': true,
    'bottomBorderRadiusNone': nonRefundableExtrasExist,
  });

  // Se hizo maquetado, actualmente no existe informacion real para asignar esto
  const showPoints = false;

  return (
    <div className='RefundAccoundAndCardInfo'>
      <div className='RefundAccoundAndCardInfo-container'>
        { showPoints && (
          <>
            <div className='RefundAccoundAndCardInfo-container-pointsRefund'>
              <div className='RefundAccoundAndCardInfo-container-pointsRefund-pointsInfo'>
                <Pictogram
                  className='RefundAccoundAndCardInfo-container-pointsRefund-pointsInfo-logo'
                  id='AerowalletWhiteBackground'
                />
                <div className='RefundAccoundAndCardInfo-container-pointsRefund-pointsInfo-accountInfo'>
                  <TranslatedCopy
                    className='RefundAccoundAndCardInfo-container-pointsRefund-pointsInfo-accountInfo-title'
                    copyID='MYB_REFUND_IN_POINTS'
                  />
                  <p className='RefundAccoundAndCardInfo-container-pointsRefund-pointsInfo-accountInfo-accountName'>
                  </p>
                </div>
              </div>
              <div className='RefundAccoundAndCardInfo-container-pointsRefund-pointsAmount'>
                { '0 ' }
                <TranslatedCopy
                  className='RefundAccoundAndCardInfo-container-pointsRefund-pointsAmount-pointsText'
                  copyID='MYB_POINTS_SELECT'
                  tagName='span'
                />
              </div>
            </div>
            <div className='RefundAccoundAndCardInfo-container-horizontalLine' />
          </>
        ) }
        { cardNumbers.map((cardNumber, index) => {
          return (
            <div className='RefundAccoundAndCardInfo-container-cardRefund' key={ index }>
              <div
                className='RefundAccoundAndCardInfo-container-cardRefund-cardInfo'
                key={ cardNumber }
              >
                <Pictogram
                  id='Visa'
                  className='RefundAccoundAndCardInfo-container-cardRefund-cardInfo--cardLogo'
                />
                <div className='RefundAccoundAndCardInfo-container-cardRefund-cardInfo-bankCardDetails'>
                  <TranslatedCopy
                    className='RefundAccoundAndCardInfo-container-cardRefund-cardInfo-bankCardDetails--bankCardNote'
                    copyID='MYB_BANK_CARD_REFUND'
                    tagName='p'
                  />
                  <p className='RefundAccoundAndCardInfo-container-cardRefund-cardInfo-bankCardDetails--refundCardDetails'>
                    <TranslatedCopy copyID='MYB_CARD' />
                    { ` **** ${cardNumber}` }
                  </p>
                </div>
              </div>
              <div className='RefundAccoundAndCardInfo-container-cardRefund-totalToRefundContainer'>
                <p className='RefundAccoundAndCardInfo-container-cardRefund-totalToRefundContainer--amount'>
                  { `$${ formatAmountWithDecimals(total, decimals) }` }
                </p>
                <p className='RefundAccoundAndCardInfo-container-cardRefund-totalToRefundContainer--totalAmountCurrency'>
                  { currencyOfRefund }
                </p>
              </div>
            </div>
          );
        }) }
      </div>
      <div className={ nonRefundableClass }>
        <TranslatedCopy
          copyID='MYB_TOTAL_TO_REFUND'
          tagName='span'
        />
        <div className='RefundAccoundAndCardInfo-totalToRefund-totalSum'>
          { showPoints &&
            <>
              { '0 ' }
              <TranslatedCopy
                className='RefundAccoundAndCardInfo-totalToRefund-totalSum-pointsText'
                copyID='MYB_POINTS_SELECT'
                tagName='span'
              />
              { ' + ' }
            </>
          }
          <span className='RefundAccoundAndCardInfo-totalToRefund-totalSum-cash'>
            { `$${ formatAmountWithDecimals(total, decimals) }` }
            { ' ' }
          </span>
          <span className='RefundAccoundAndCardInfo-totalToRefund-totalSum-currency'>{ currencyOfRefund }</span>
        </div>
      </div>
    </div>
  );
};

export default RefundAccoundAndCardInfo;
